var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_57_50",
    "data-name": "Component 57 \\u2013 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2764",
    "data-name": "Rectangle 2764",
    width: 20,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13171",
    "data-name": "Group 13171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13170",
    "data-name": "Group 13170",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13031",
    "data-name": "Path 13031",
    d: "M3.677,8.784c.141-.162.269-.335.424-.482a.817.817,0,0,1,1.166,0,.8.8,0,0,1,0,1.138q-.958.987-1.949,1.944a.794.794,0,0,1-1.141,0Q1.189,10.424.232,9.435A.8.8,0,0,1,.239,8.3.822.822,0,0,1,1.407,8.3c.156.146.288.318.431.478l.082-.035c.028-.279.051-.558.085-.837a9,9,0,1,1,5.007,9.185c-.551-.267-.757-.707-.539-1.167s.7-.57,1.25-.3A7.366,7.366,0,1,0,3.582,8.508c-.005.073,0,.146,0,.219l.1.057",
    fill: "#600097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13032",
    "data-name": "Path 13032",
    d: "M10.139,6.6c0-.862-.005-1.724,0-2.586a.818.818,0,0,1,.535-.807.755.755,0,0,1,.881.222,1.414,1.414,0,0,1,.218.716c.019,1.487.015,2.974.005,4.461a.711.711,0,0,0,.239.563q1.078,1.052,2.134,2.124a.816.816,0,0,1,.142,1.035.79.79,0,0,1-.927.346,1.107,1.107,0,0,1-.4-.257c-.845-.832-1.682-1.675-2.527-2.509a.989.989,0,0,1-.3-.754c.005-.851,0-1.7,0-2.554",
    fill: "#600097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLog);
export default __webpack_public_path__ + "static/media/activityLog.41596c7b30a360705dd6651733843f9f.svg";
export { ForwardRef as ReactComponent };